import { colorSchema as orcColorSchema } from '@ontruck/orc';

const colorSchema = color => props => {
  return props && props.theme && props.theme.base.colorSchema[color];
};

const textSizes = size => props => props.theme.base.textSizes[size];
const weights = weight => {
  const values = {
    bold: 700,
    medium: 500,
    regular: 400
  };
  return values[weight] || values.regular;
};

const gridSizes = size => props => props.theme.base.gridSizes[size];
const gridSizesNumber = size => props =>
  Number(gridSizes(size)(props).replace(/[^0-9]/g, ''));

const themeBaseOverwrite = {
  colorSchema: {
    primary: orcColorSchema.primary500,
    secondary: orcColorSchema.primary100
  },
  gridSizes: {
    XS: '4px',
    S: '8px',
    M: '16px',
    L: '24px',
    XL: '40px',
    XXL: '64px',
    XXXL: '128px'
  }
};

export {
  colorSchema,
  gridSizes,
  themeBaseOverwrite,
  textSizes,
  gridSizesNumber,
  weights
};
